import { Box, Container, Typography } from '@material-ui/core';
import { compose } from 'ramda';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation, withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { postMessage } from '../utils/postMessage';
import LocaleKeys from '../locales/keys';
import backArrow from '../images/icon-left.svg';
import AccountInfoForm from './components/accountInfoForm';
import Devices from '../subscriptionInfo/containers/Devices';
import { useEffect, useState } from 'react';

const useStyles = makeStyles((theme) => ({
  hidden: {
    display: 'none',
  },
  container: {
    backgroundColor: theme.palette.background.default,
    borderRadius: '10px',
    border: `1px solid ${theme.palette.custom.lightBlack}`,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '15px',
    padding: 0,
    maxWidth: '640px',
    [theme.breakpoints.down('lg')]: {
      maxWidth: '638px',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '368px',
    },
  },
  link: {
    '&:hover': {
      color: theme.palette.primary.main,
      cursor: 'pointer',
    },
  },
  backArrow: {
    float: 'left',
  },
  back: {
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}));

function Accountinfo(props) {
  const {
    profileType,
    showAlreadyHaveAccountMessage,
    showBackButton,
    leadSource,
    apiUrl,
  } = props;

  const classes = useStyles();
  const { t } = useTranslation();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    postMessage('module.showLoader');
  }, []);

  useEffect(() => {
    if (isReady) {
      postMessage('module.hideLoader');
    }
  }, [isReady]);

  return (
    <>
      <Container
        className={`${classes.container} ${isReady ? '' : classes.hidden}`}
      >
        <Box className={classes.accountInfoContainer}>
          <Box>
            {showBackButton ? (
              <Link
                to="/"
                className={classes.link}
                underline="none"
                data-testid="back-link"
                onClick={(e) => {
                  e.preventDefault();
                  postMessage('module.backButton', {});
                }}
              >
                <Typography color="primary" className={classes.backArrow}>
                  <img src={backArrow} alt={t(LocaleKeys.registration.back)} />
                </Typography>

                <Typography
                  color="textPrimary"
                  variant="h6"
                  className={classes.back}
                >
                  {t(LocaleKeys.registration.back)}
                </Typography>
              </Link>
            ) : null}
          </Box>
          <AccountInfoForm
            profileType={profileType}
            showAlreadyHaveAccountMessage={showAlreadyHaveAccountMessage}
            leadSource={leadSource}
            apiUrl={apiUrl}
            setIsReady={setIsReady}
          />
        </Box>
      </Container>
      <Container
        className={`${classes.container} ${isReady ? '' : classes.hidden}`}
      >
        <Box className={classes.accountInfoContainer}>
          <Box className={classes.root}>
            <Box className="panel-body">
              <Devices showDevicesContainer={true} />
            </Box>
          </Box>
        </Box>
      </Container>
    </>
  );
}

export default compose(withTranslation())(Accountinfo);
